import React, { useState } from "react";
import "./CheckCardStatus.css";
import {
  FaIndianRupeeSign,
  FaStar,
  FaRegStarHalfStroke,
} from "react-icons/fa6";
import { IoIosStarOutline } from "react-icons/io";
import Button from "react-bootstrap/Button";
import { ColorRing } from "react-loader-spinner";
import axios from "axios";
import { AnimatePresence } from "framer-motion";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { CheckCircle } from "lucide-react";

const CheckCardStatus = ({ data }) => {
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [indexs, setIndex] = useState(null);

  const cardData = [
    {
      image: "../../../../images/card/image.png",
      bestFor:
        "Best For : Chosen based on user's income level and interest in shopping benefits",
      name: "Wells Fargo Active Cash Card",
      fee: "0",
      rate: "2 %",
      offers: "2000",
      creditScore: "690-850",
      star: 3.5,
    },
    {
      image: "../../../../images/card/image1.png",
      bestFor:
        "Best For : Chosen based on user's income level and interest in shopping benefits",
      name: "Flipkart Axis Credit Card",
      fee: "0",
      rate: "2 %",
      offers: "2000",
      creditScore: "690-850",
      star: 4.5,
    },
    {
      image: "../../../../images/card/image2.png",
      bestFor:
        "Best For : Chosen based on user's income level and interest in shopping benefits",
      name: "Wells Fargo Active Cash Card",
      fee: "0",
      rate: "2 %",
      offers: "2000",
      creditScore: "690-850",
      star: 1.5,
    },
    {
      image: "../../../../images/card/image.png",
      bestFor:
        "Best For : Chosen based on user's income level and interest in shopping benefits",
      name: "Flipkart Axis Credit Card",
      fee: "0",
      rate: "2 %",
      offers: "2000",
      creditScore: "690-850",
      star: 2.5,
    },
    {
      image: "../../../../images/card/image1.png",
      bestFor:
        "Best For : Chosen based on user's income level and interest in shopping benefits",
      name: "Wells Fargo Active Cash CardCard",
      fee: "0",
      rate: "2 %",
      offers: "2000",
      creditScore: "690-850",
      star: 5,
    },
  ];

  const StarRating = ({ rating }) => {
    const maxStars = 5;
    const stars = [];

    for (let i = 1; i <= maxStars; i++) {
      if (i <= rating) {
        stars.push(
          <FaStar
            key={i}
            fill="#25866a"
            stroke="#25866a"
            className="card-rating-star"
          />
        );
      } else if (i - 0.5 === rating) {
        stars.push(
          <FaRegStarHalfStroke
            key={i}
            fill="#25866a"
            stroke="#25866a"
            className="card-rating-star"
          />
        );
      } else {
        stars.push(
          <IoIosStarOutline
            key={i}
            fill="#25866a"
            stroke="#25866a"
            className="card-rating-star"
          />
        );
      }
    }

    return <div className="flex space-x-1">{stars}</div>;
  };
  const handleSubmit = async (interest) => {
    const formData = new FormData();
    formData.append("card_name", data.specificCard);
    formData.append("amount", 0);
    formData.append("tenure", 0);
    formData.append("iRate", interest);
    formData.append("emi", data.monthlyemi);
    formData.append("formId", "0");
    setLoader(true);

    const response = await axios.post(
      `${process.env.REACT_APP_URL}/applyLoan`,
      formData
    );

    if (response.data.status) {
      // setShow(true);
      setLoader(false);
    }
    setLoader(false);
  };

  return (
    <>
      <div id="Loan-Check-Card-Availability">
        <div className="CheckCard-bottom-contentCon">
          <p id="CheckCard-bottom-title">
            Recommended Credit Cards Just for You
          </p>

          {data?.res?.otherCards?.map((item, index) => (
            <div className="card-bottom-con" key={index}>
              <div className="travel-con">{/* <p>{item.bestFor}</p> */}</div>

              <div className="row p-0 m-0">
                <div className="col-12 col-md-4 p-0 m-0">
                  <img
                    src={item.card_img}
                    alt="card-image"
                    className="card-img"
                  />
                </div>

                <div className="col-12 col-md-8 px-0 m-0">
                  <div className="row p-0 m-0">
                    <div className="col-12 col-md-8 m-0 p-0">
                      <div>
                        <div className="d-block d-md-none my-3 my-md-0">
                          <p className="card-rating-left">MinEmi Ratings</p>
                          <div className="card-star-left">
                            <StarRating rating={item.rating / 2} />
                          </div>
                        </div>

                        <p className="card-name">{item.card_name}</p>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0">
                            Annual Fee <span> :</span>{" "}
                          </p>
                          &nbsp;&nbsp;&nbsp;
                          <p className="text-content m-0 p-0 d-flex align-items-center">
                            <FaIndianRupeeSign className="rupee-icon" />
                            {item.annual_fees}
                          </p>
                        </div>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0">
                            Reward Rate <span> :</span>{" "}
                          </p>
                          &nbsp;&nbsp;&nbsp;
                          <p className="text-content m-0 p-0">
                            {item.reward_rate} ( Cashback )
                          </p>
                        </div>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0">
                            Intro Offers <span> :</span>{" "}
                          </p>
                          &nbsp;&nbsp;&nbsp;
                          <p className="text-content m-0 p-0 ">
                            &#x20B9;
                            {item.intro_offer} ( Cashback )
                          </p>
                        </div>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0">
                            Recommend Credit Score <span> :</span>{" "}
                          </p>
                          &nbsp;&nbsp;&nbsp;
                          <p className="text-content m-0 p-0">
                            {item.min_cibil}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex flex-column justify-content-between m-0 p-0">
                      <div className="d-none d-md-block">
                        <p className="card-rating-text">MinEmi Ratings</p>
                        <div className="card-star-con">
                          <StarRating rating={item.rating / 2} />
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4 mt-md-0">
                        {!loader && indexs != index ? (
                          <Button
                            className="check-card-apply-btn"
                            type="submit"
                            onClick={() => {
                              handleSubmit(item.interest_rate);
                              setIndex(index);
                            }}
                          >
                            Apply Now
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="check-card-apply-btn"
                          >
                            <ColorRing
                              visible={true}
                              height="30"
                              width="30"
                              ariaLabel="color-ring-loading"
                              wrapperStyle={{}}
                              wrapperClass="color-ring-wrapper"
                              colors={[
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                                "#ffffff",
                              ]}
                            />
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Dialog open={show} onOpenChange={setShow}>
        <DialogContent className="sm:max-w-md">
          <div>
            <DialogTitle
              className=" font-bold text-center"
              style={{
                fontWeight: "bold",
                fontSize: 21,
                fontFamily: "Archivo",
                color: "#59266D",
              }}
            >
              Application Submitted Sucessfully!
            </DialogTitle>
          </div>

          <AnimatePresence mode="wait">
            <div
              key="success"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="flex flex-col items-center justify-center py-3 space-y-3"
            >
              <div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", damping: 10, stiffness: 100 }}
              >
                <CheckCircle className="w-16 h-16 text-green-500" />
              </div>
              <p className="text-center text-muted-foreground">
                Your responses have been recorded. Our team will review your
                feedback and get back to you soon!
              </p>
            </div>
          </AnimatePresence>

          <div className="sm:justify-center" style={{ display: "flex" }}>
            <Button
              id="loans-modalCloseBtn"
              onClick={() => setShow(false)}
              variant="outline"
              style={{ margin: "auto" }}
              className="mt-2 transition-all duration-300 hover:bg-primary hover:text-primary-foreground text-center"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CheckCardStatus;
